var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: { okBtnAction: "onHold" },
      on: { onCloseClick: _vm.cleanModalState },
    },
    [
      _c("div", {
        attrs: { slot: "title" },
        domProps: {
          innerHTML: _vm._s(_vm.$t("tenantProjects.greenFitOut.onHoldAlert")),
        },
        slot: "title",
      }),
      _vm._v(" "),
      _c("HKLForm", { ref: "form", staticClass: "check-validation" }, [
        _c("div", { staticClass: "text-input" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.onHoldComment,
                expression: "onHoldComment",
              },
              { name: "autosize", rawName: "v-autosize" },
              { name: "hkldinput", rawName: "v-hkldinput" },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "string",
                  required: true,
                },
                expression:
                  "{\n          type: 'string',\n          required: true\n        }",
              },
            ],
            domProps: { value: _vm.onHoldComment },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.onHoldComment = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }